var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResolved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 .833a9.167 9.167 0 100 18.334A9.167 9.167 0 0010 .833zm3.973 7.617a.834.834 0 10-1.28-1.067l-3.583 4.3-1.854-1.856a.833.833 0 00-1.178 1.179l2.5 2.5a.833.833 0 001.229-.056l4.166-5z",
    fill: "#2ECC71"
  })));
}

export default SvgResolved;